const TermsOfUseLinks = {
  termsOfUseLink: 'https://www.oracle.com/us/legal/terms/index.html',
  privacyLink: 'https://www.oracle.com/legal/privacy/index.html',
  japanPrivacyLink: 'https://www.oracle.com/jp/legal/information-protection/basic-policy/public-notice/index.html',
  affiliatesGloballyLink: 'https://www.oracle.com/corporate/contact/global.html',
  thirdPartyLink: 'https://www.oracle.com/corporate/contact/suppliers.html',
};

export default TermsOfUseLinks;
